module.exports = __webpack_public_path__ + "static/media/20170806_45day_2208AT.ab3ac664.jpg";